import tender1 from '@/assets/tenders/tender-1.pdf';
import tender2 from '@/assets/tenders/tender-2.pdf';
import tender3 from '@/assets/tenders/tender-3.pdf';
import tender4 from '@/assets/tenders/tender-4.pdf';
import tender5 from '@/assets/tenders/tender-5.pdf';
import tender6 from '@/assets/tenders/tender-6.pdf';
import tender7 from '@/assets/tenders/tender-7.pdf';
import tender8 from '@/assets/tenders/tender-8.pdf';
import tender9 from '@/assets/tenders/tender-9.pdf';
import tender10 from '@/assets/tenders/tender-10.pdf';
import tender11 from '@/assets/tenders/tender-11.pdf';
import tender12 from '@/assets/tenders/tender-12.pdf';
import tender13 from '@/assets/tenders/tender-13.pdf';
import tender14 from '@/assets/tenders/tender-14.pdf';
import tender15 from '@/assets/tenders/tender-15.pdf';
import tender16 from '@/assets/tenders/tender-16.pdf';

export interface OmcTender {
  id: number;
  srNo: number;
  title: string;
  date: string;
  esy: string;
  quantity: string;
  location: string;
  pdfUrl: string;
}

export const omcTendersData: OmcTender[] = [
  {
    id: 1,
    srNo: 1,
    title: "SUPPLY OF AROUND 1050 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "26-09-2025",
    esy: "2025-26",
    quantity: "1050 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender1
  },
  {
    id: 2,
    srNo: 2,
    title: "SUPPLY OF AROUND 66.47 CRORE LITRES OF ETHANOL AT NAYARA LOCATION",
    date: "25-09-2025",
    esy: "2025-26",
    quantity: "66.47 Crore Litres",
    location: "Nayara Location",
    pdfUrl: tender2
  },
  {
    id: 3,
    srNo: 3,
    title: "SUPPLY OF AROUND 1050 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "23-09-2025",
    esy: "2025-26",
    quantity: "1050 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender3
  },
  {
    id: 4,
    srNo: 4,
    title: "SUPPLY OF AROUND 58.60 CRORE LITRES OF ETHANOL AT RELIANCE LOCATIONS",
    date: "05-09-2025",
    esy: "2025-26",
    quantity: "58.60 Crore Litres",
    location: "Reliance Locations",
    pdfUrl: tender4
  },
  {
    id: 5,
    srNo: 5,
    title: "SUPPLY OF AROUND 49 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "01-07-2025",
    esy: "2024-25",
    quantity: "49 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender5
  },
  {
    id: 6,
    srNo: 6,
    title: "SUPPLY OF AROUND 29 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "15-05-2025",
    esy: "2024-25",
    quantity: "29 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender6
  },
  {
    id: 7,
    srNo: 7,
    title: "SUPPLY OF AROUND 124 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "29-01-2025",
    esy: "2024-25",
    quantity: "124 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender7
  },
  {
    id: 8,
    srNo: 8,
    title: "SUPPLY OF AROUND 88 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "06-12-2024",
    esy: "2024-25",
    quantity: "88 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender8
  },
  {
    id: 9,
    srNo: 9,
    title: "SUPPLY OF AROUND 916 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "26-09-2024",
    esy: "2024-25",
    quantity: "916 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender9
  },
  {
    id: 10,
    srNo: 10,
    title: "SUPPLY OF AROUND 66 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "15-05-2024",
    esy: "2023-24",
    quantity: "66 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender10
  },
  {
    id: 11,
    srNo: 11,
    title: "SUPPLY OF AROUND 825 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "01-11-2023",
    esy: "2023-24",
    quantity: "825 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender11
  },
  {
    id: 12,
    srNo: 12,
    title: "SUPPLY OF AROUND 825 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "20-10-2023",
    esy: "2023-24",
    quantity: "825 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender12
  },
  {
    id: 13,
    srNo: 13,
    title: "SUPPLY OF AROUND 651 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "18-10-2022",
    esy: "2022-23",
    quantity: "651 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender13
  },
  {
    id: 14,
    srNo: 14,
    title: "SUPPLY OF AROUND 106 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "08-07-2022",
    esy: "2021-22",
    quantity: "106 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender14
  },
  {
    id: 15,
    srNo: 15,
    title: "SUPPLY OF AROUND 459 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "28-10-2021",
    esy: "2021-22",
    quantity: "459 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender15
  },
  {
    id: 16,
    srNo: 16,
    title: "SUPPLY OF AROUND 429 CRORE LITRES OF ETHANOL AT OMC LOCATIONS",
    date: "01-12-2020",
    esy: "2020-21",
    quantity: "429 Crore Litres",
    location: "OMC Locations",
    pdfUrl: tender16
  }
];
